import UploadPackageDrawer from './drawer/UploadPackageDrawer'
import CreateVersionDrawer from './drawer/CreateVersionDrawer'
import UploadProgressPanel from './UploadProgressPanel'

/**
 * 版本两段式流程宿主：上传抽屉（仅主包）+ 配置抽屉（子包 + 表单）。
 * 右下角浮层只承载子包后台上传。
 * 挂在 AuthGuard 下，覆盖工作台与应用详情。
 */
export default function VersionFlowHost() {
  return (
    <>
      <UploadPackageDrawer />
      <CreateVersionDrawer />
      <UploadProgressPanel />
    </>
  )
}
